export default "__VITE_ASSET__DZKoOT0C__"